<template>
  <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Commune : {{ commune.ll_commune }}
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <template>
      <template>
        <v-btn
          @click="dialog = !dialog"
          color="primary"
          dark
          class="ma-2"
          rounded
        >
          <v-icon left dark> mdi-plus-circle-outline </v-icon>Nouveau
          Fokontany</v-btn
        >
      </template>
      <!--       <v-btn @click="traiterSuperviseur()">traiter</v-btn> -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-form ref="form_new_fokontany" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline">Nouveau Fokontany</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-text-field
                    dense
                    v-model="ll_fokontany"
                    label="Nom du Fokontany"
                    prepend-icon="person"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded color="warning" dark @click="resetForm"
                >Annuler</v-btn
              >
              <v-btn
                rounded
                :loading="newFokontanyLoading"
                color="primary"
                dark
                @click="createFokontany"
                >Créer Fokontany</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </template>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="_.sortBy(Fokontanys, ['ll_fokontany'])"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="gotToItem(item)">
            mdi-chevron-right
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      commune: {},
      Fokontanys: [],
      ll_fokontany: "",
      newFokontanyLoading: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      dialog: false,
      search: "",
      headers: [
        {
          text: "Fokontany",
          value: "ll_fokontany",
        },
        { text: "Commune", value: "ll_commune" },
        { text: "District", value: "ll_district" },
        { text: "Région", value: "ll_region" },
        { text: "Province", value: "ll_province" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  mounted() {
    this.GetInfos();
  },
  methods: {
    createFokontany() {
      let self = this;
      this.newFokontanyLoading = true;
      let uuid = "000000000000000aaaa-" + this.$uuid.v4();
      if (this.$refs.form_new_fokontany.validate()) {
        var newFokontany = {
          id: uuid,
          id_country: 133,
          ll_fokontany: self.ll_fokontany,
          ll_commune: self.commune.ll_commune,
          id_commune: self.commune.id,
          ll_district: self.commune.ll_district,
          id_district: self.commune.id_district,
          ll_region: self.commune.ll_region,
          id_region: self.commune.id_region,
          ll_province: self.commune.ll_province,
          id_province: self.commune.id_province,
        };
        // Add a new document in collection "communes"

        self.$firebase
          .firestore()
          .collection("fokontanys")
          .doc(uuid)
          .set(newFokontany)
          .then(() => {
            console.log("Document successfully written!");
            this.GetInfos();
            self.newFokontanyLoading = false;
            self.resetForm();
            self.dialog = false;
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },
    resetForm() {
      this.$refs.form_new_fokontany.reset();
      this.dialog = false;
    },
    editItem(item) {
      console.log(item);
    },

    deleteItem(item) {
      this.$confirm("Voulez vous vraiment supprimer ce fokontany").then(
        (res) => {
          if (res) {
            console.log(item);
          }
        }
      );
    },

    gotToItem(item) {
      this.$router.push("/geographie/fokontany/" + item.id);
    },
    GetInfos() {
      let self = this;
      var docRef = this.$firebase
        .firestore()
        .collection("communes")
        .doc(this.$route.params.id);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());

            self.commune = doc.data();

            self.Fokontanys = [];
            self.$firebase
              .firestore()
              .collection("fokontanys")
              .where("id_commune", "in", [
                self.$route.params.id.toString(),
                self.$route.params.id,
              ])
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  self.Fokontanys.push({
                    ...doc.data(),
                    id: doc.id,
                  });
                });
              })
              .catch((error) => {
                console.log("Error getting documents: ", error);
              });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style scoped></style>
